/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import styles from './SearchQuestions.module.scss';

import { SectionShell } from '../../atoms/SectionShell/SectionShell';
import type { SearchQuestionsProps } from './SearchQuestions.types';

export const SearchQuestions = ({ topic, className }: SearchQuestionsProps) => {
  const { t } = useInt();

  if (topic.additional_search_questions.length === 0) {
    return null;
  }

  return (
    <SectionShell id="search-questions" title={t('Related questions')} className={className}>
      <ul className={styles['list']}>
        {topic.additional_search_questions.map((question, index) => (
          <li key={index} className={styles['row']}>
            {question}
          </li>
        ))}
      </ul>
    </SectionShell>
  );
};
